export enum ChapterSubType {
  CompleteCourse = 'complete_course',
  NoEmail = 'no_email',
  Standard = 'standard',
}
